/* eslint-disable import/prefer-default-export */
/** LaunchDarkly flag for the product-scoped invoice lookup. */
export const PRODUCT_INVOICE_LOOKUP = 'releaseFeProductInvoiceLookup';
